import {useNavigate, useSearchParams} from "react-router-dom";
import {roleSelector, useGetRoleQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {RoleProfile} from "../../components/profile/RoleProfile/RoleProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const RoleProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.role", "Role") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <RoleProfilePage id={id}/>;
};

export const RoleProfilePage = (props: Props) => {
  const {id} = props;

  const selectRole = useMemo(() => {
    return roleSelector()
  }, []);

  const {role, isFetching} = useGetRoleQuery(id ?? skipToken, {
    selectFromResult: (result) => ({
      role: selectRole(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage permissions={["role_view"]} entity={role} isLoading={isFetching}>
      {(entity) => (
        <RoleProfile role={entity}/>
      )}
    </EntityProfilePage>
  )
};
